<script lang="ts">
  interface Props {
    size?: number
    // When the mark sits next to the visible "RentReadyPet" wordmark, set this
    // so assistive tech doesn't announce the brand name twice.
    decorative?: boolean
  }
  let { size = 30, decorative = false }: Props = $props()
</script>

<svg
  class="brand-mark"
  viewBox="0 0 64 64"
  width={size}
  height={size}
  role={decorative ? undefined : 'img'}
  aria-label={decorative ? undefined : 'RentReadyPet'}
  aria-hidden={decorative ? 'true' : undefined}
>
  <polygon points="16,41 32,41 27,30 8,31" fill="#a9611f" />
  <polygon points="32,41 48,41 56,31 37,30" fill="#a9611f" />
  <ellipse cx="22" cy="27" rx="5.2" ry="9.5" fill="#a9611f" />
  <ellipse cx="42" cy="27" rx="5.2" ry="9.5" fill="#a9611f" />
  <circle cx="32" cy="26" r="12.5" fill="#f4a934" />
  <ellipse cx="32" cy="32" rx="7.5" ry="6" fill="#fde1a3" />
  <circle cx="26.5" cy="24" r="1.8" fill="#2a2e37" />
  <circle cx="37.5" cy="24" r="1.8" fill="#2a2e37" />
  <ellipse cx="32" cy="30" rx="2.4" ry="1.8" fill="#2a2e37" />
  <path
    d="M32 31.8 v2.2 M32 34 q-3 2.4 -5.5 0.4 M32 34 q3 2.4 5.5 0.4"
    stroke="#2a2e37"
    stroke-width="1.2"
    fill="none"
    stroke-linecap="round"
  />
  <path d="M30.6 34.6 q1.4 2.8 2.8 0 Z" fill="#fb7185" />
  <path d="M15 41 h34 l-2.5 19 h-29 Z" fill="#c88a3d" />
  <path d="M32 41 v19" stroke="#a9611f" stroke-width="0.8" opacity="0.45" />
  <ellipse cx="24.5" cy="41" rx="3.2" ry="2.4" fill="#fde1a3" />
  <ellipse cx="39.5" cy="41" rx="3.2" ry="2.4" fill="#fde1a3" />
</svg>

<style>
  .brand-mark {
    display: block;
    flex: none;
  }
</style>
